import React, {useEffect, useState} from 'react';
import {Button, FormControl, InputGroup} from "react-bootstrap";
import {IoCloseSharp, IoSearchOutline} from "react-icons/io5";
import {useTranslation} from "react-i18next";
import {useDebounceCallback} from "../../../Hooks/useDebounceCallback";
import ConditionalRender from "../../ConditionalRender";
import {useHover} from "../../../Hooks/visual/useHover";

const Search = ({onSearch, onChange, className, text, searchBtn, debounceMs = 500}) => {
    const {t} = useTranslation();
    const [input, setInput] = useState('');

    useEffect(() => {
        onChange && onChange(input);
    }, [input, onChange]);

    const handleSearch = () => {
        onSearch && onSearch(input);
    }

    useDebounceCallback(handleSearch, debounceMs, [input]);

    const baseStyle = {
        right: 38,
        zIndex: 10,
        top: 7,
        cursor: 'pointer',
        borderRadius: '50%',
        transition: '0.1s'
    }

    const hoverStyle = {
        ...baseStyle,
        backgroundColor: '#eaeaea',
        boxShadow: '0px 0px 5px 0px #a6a6a6'
    }

    const {onMouseEnter, onMouseLeave, style} = useHover(hoverStyle, baseStyle)

    if(!text)
    {
        text = t('global.operations.search');
    }
    if(!searchBtn)
    {
        searchBtn = {
            element: <IoSearchOutline/>,
            variant: 'outline-secondary'
        }
    }
    else if(!searchBtn.element)
    {
        searchBtn.element = <IoSearchOutline/>;
    }
    else if(!searchBtn.variant)
    {
        searchBtn.variant = 'outline-secondary';
    }

    const handleClear = () => {
        setInput('');
        onMouseLeave()
    }

    return (
        <InputGroup size={'sm'} className={className}>
            <ConditionalRender condition={input.length > 0}>
                <IoCloseSharp className={'position-absolute'} style={style} onClick={handleClear} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} tabIndex={0}/>
            </ConditionalRender>
            <FormControl className={'shadow-none'} placeholder={text} value={input} onChange={(e) => setInput(e.target.value)}/>
            <Button className={'shadow-none border-secondary-subtle'} variant={'outline-secondary'} id="button-addon2" onClick={handleSearch}>
                {searchBtn.element}
            </Button>
        </InputGroup>
    );
};

export default Search;